import { Commodity } from '../models/commodity';
import { WeightUnitEnum } from '../enum/weight-unit.enum';
import { CurrencyEnum } from '../enum/currency.enum';

export const emptyCommodity: Commodity = {
    id: null,
    description: '',
    country: null,
    quantity: 1,
    unitOfMeasure: 'EA',
    province: null,
    netCost: 0,
    markings: '',
    weight: 1,
    producer: null,
    harmonizedCode: '0000.00.00.00',
    preference: null,
    weightUnit: WeightUnitEnum.KG,
    pieces: 1,
    price: 0,
    currency: CurrencyEnum.USD,
    templateId: null
};
